import jwtDecode from 'jwt-decode';

import { GoogleUnableToAuthenticateUserError } from '../Errors';
import { ensureSdkLoaded } from './sdk/OneTapSdkLoader';

let credentialResponse;
let profile;

function getLoggedInUser() {
    if (!profile) {
        return undefined;
    }

    return {
        email: profile.email,
        firstName: profile.given_name,
        lastName: profile.family_name,
    };
}

function getUserInteraction() {
    return credentialResponse
        ? credentialResponse.select_by
        : undefined;
}

function onLogIn(response) {
    credentialResponse = response;
    profile = jwtDecode(credentialResponse.credential);
}

async function logIn() {
    await ensureSdkLoaded(onLogIn);

    return new Promise((resolve, reject) => {
        window.google.accounts.id.prompt((notification) => {
            const isSkippedMoment = notification.isSkippedMoment();
            const isDismissedMoment = notification.isDismissedMoment();
            const gotCredential = notification.getDismissedReason() === 'credential_returned';
            const dismissedWithoutCred = isDismissedMoment && !gotCredential;
            const unableToAuthenticate = isSkippedMoment || dismissedWithoutCred;

            if (unableToAuthenticate) {
                reject(new GoogleUnableToAuthenticateUserError());
            }

            if (isDismissedMoment && gotCredential) {
                resolve(credentialResponse.credential);
            }
        });
    });
}

async function logOut() {
    credentialResponse = undefined;
    profile = undefined;
    if (window.google) {
        window.google.accounts.id.disableAutoSelect();
    }
}

const googleOneTapService = {
    getLoggedInUser,
    getUserInteraction,
    logIn,
    logOut,
};

export default googleOneTapService;
